import type { AccountResetPasswordMailRequest } from '@/modules/accounts/types.ts'
import { apiClient } from '@/utils/axios.ts'

async function requestPasswordResetMail(
  resetPasswordMailData: AccountResetPasswordMailRequest,
): Promise<void> {
  const response = await apiClient.post(
    `/mail/reset-password/unauthenticated/${resetPasswordMailData.email}`,
  )

  return response.data
}

async function isValidPasswordResetToken(token: string): Promise<void> {
  const response = await apiClient.get('/auth/password', {
    params: {
      token,
    },
  })

  return response.data
}

export const passwordService = {
  requestPasswordResetMail,
  isValidPasswordResetToken,
}
